module.exports = __webpack_public_path__ + "img/img-top2.db40c8dc.png";